var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-revoke",class:{ mine: _vm.data.mine }},[_c('span',{attrs:{"title":_vm.formatTime},domProps:{"innerHTML":_vm._s(_vm.processedText)},on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }